<template>
<div class="chapter">
<div class="inner_page">
<article epub:type="introduction">
<section epub:type="division">
<p class="C333" id="page_xv">
<strong>INTRODUCTION</strong>
</p>
</section>
</article>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 09_Introduction.vue?b86d96da